import React from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router';
import { FormattedMessage } from 'react-intl';
import Menu from '../Menu';
import Divider from '../Divider';
import Icon from '../Icon';
import RepVisitsPendingCounter from '../RepVisitsPendingCounter';
import FeatureEnabled from '../FeatureEnabled';
import { REPVISITS_RSVP_COUNTER } from '../../containers/Authorization/constants';
import { active } from './styles.css';

function getEventTabActiveClass(router, path) {
  return router.location.pathname.includes(path) ? 'navActive' : '';
}

const MainMenu = (props) => (
  <nav aria-label="RepVisits Menu">
    <Menu className={props.className} stackable as="ul" pointing secondary size="huge" styleName="navMenu">
      <Menu.Header styleName="navMenu-header">
        <span>
          <FormattedMessage id="settings.your-notifications.repVisitsHeading" defaultMessage="REPVISITS" />
        </span>
        <span styleName="align-header-right">
          <Icon
            styleName="closeIcon"
            onClick={props.toggleVisibility}
            name="x"
            aria-hidden="true"
            size="large"
          />
        </span>
      </Menu.Header>
      <Divider styleName="menu-divider" />
      <Menu.Item as="li" link styleName={`navMenu-item ${getEventTabActiveClass(props.router, '/rep-visits/overview')}`}>
        <Link
          role="menuitem"
          activeClassName={active}
          to="/rep-visits/overview"
          styleName="navMenu-link"
          onClick={props.toggleVisibility}
        >
          <FormattedMessage id="repvisits.menu.overview" defaultMessage="Overview" />
        </Link>
      </Menu.Item>
      <Divider styleName="menu-divider" />
      <Menu.Item as="li" link styleName={`navMenu-item ${getEventTabActiveClass(props.router, '/rep-visits/search')}`}>
        <Link
          role="menuitem"
          activeClassName={active}
          to="/rep-visits/search"
          styleName="navMenu-link"
          onClick={props.toggleVisibility}
        >
          <FormattedMessage id="repvisits.menu.searchAndSchedule" defaultMessage="Search and Schedule" />
        </Link>
      </Menu.Item>
      <Divider styleName="menu-divider" />
      <Menu.Item as="li" link styleName={`navMenu-item ${getEventTabActiveClass(props.router, '/rep-visits/calendar')}`}>
        <Link
          role="menuitem"
          activeClassName={active}
          to="/rep-visits/calendar"
          styleName="navMenu-link"
          onClick={props.toggleVisibility}
        >
          <FormattedMessage id="repvisits.menu.calendar" defaultMessage="Calendar" />
        </Link>
      </Menu.Item>
      <Divider styleName="menu-divider" />
      <Menu.Item as="li" link styleName={`navMenu-item ${getEventTabActiveClass(props.router, '/rep-visits/travel-plan')}`}>
        <Link
          role="menuitem"
          activeClassName={active}
          to="/rep-visits/travel-plan"
          styleName="navMenu-link"
          onClick={props.toggleVisibility}
        >
          <FormattedMessage id="repvisits.menu.travelPlan" defaultMessage="Travel Plan" />
        </Link>
      </Menu.Item>
      <Divider styleName="menu-divider" />
      <Menu.Item as="li" link styleName={`navMenu-item ${getEventTabActiveClass(props.router, '/rep-visits/contacts')}`}>
        <Link
          role="menuitem"
          activeClassName={active}
          to="/rep-visits/contacts"
          styleName="navMenu-link"
          onClick={props.toggleVisibility}
        >
          <FormattedMessage id="repvisits.menu.contacts" defaultMessage="Contacts" />
        </Link>
      </Menu.Item>
      <Divider styleName="menu-divider" />
      <Menu.Item as="li" link styleName={`navMenu-item ${getEventTabActiveClass(props.router, '/rep-visits/recommendations')}`}>
        <Link
          role="menuitem"
          activeClassName={active}
          to="/rep-visits/recommendations"
          styleName="navMenu-link"
          onClick={props.toggleVisibility}
        >
          <FormattedMessage id="repvisits.menu.recommendations" defaultMessage="Recommendations" />
        </Link>
      </Menu.Item>
      <Divider styleName="menu-divider" />
      <Menu.Item as="li" link styleName={`navMenu-item ${getEventTabActiveClass(props.router, '/rep-visits/notifications/requests')}`}>
        <Link
          role="menuitem"
          activeClassName={active}
          styleName="navMenu-link"
          to="/rep-visits/notifications/requests"
          onClick={props.toggleSecondaryMenu}
        >
          <div styleName="menu-item-content">
            <FormattedMessage id="repvisits.menu.notifications" defaultMessage="Notifications" />
            <FeatureEnabled allOf={[REPVISITS_RSVP_COUNTER]}>
              <RepVisitsPendingCounter />
            </FeatureEnabled>
          </div>
        </Link>
        <div styleName="notificationsIconContainer">
          <Icon name="angle right" size="big" styleName="notificationsIcon" onClick={props.toggleSecondaryMenu} />
        </div>
      </Menu.Item>
      <Divider styleName="menu-divider" />
      <Menu.Item as="li" link styleName={`navMenu-item ${getEventTabActiveClass(props.router, '/rep-visits/visit-feedback')}`}>
        <Link
          role="menuitem"
          activeClassName={active}
          to="/rep-visits/visit-feedback"
          styleName="navMenu-link"
          onClick={props.toggleVisibility}
        >
          <FormattedMessage id="repvisits.menu.visitFeedback" defaultMessage="Visit Feedback" />
        </Link>
      </Menu.Item>
    </Menu>
  </nav>
);

MainMenu.propTypes = {
  toggleVisibility: PropTypes.func.isRequired,
  toggleSecondaryMenu: PropTypes.func.isRequired,
  className: PropTypes.string,
  router: PropTypes.shape({
    location: PropTypes.object.isRequired,
  }).isRequired,
};

export default MainMenu;
